import { CHAT_NOTIFICATION_CATEGORIES } from "PFApp/constants/notifications";
import { Button } from "PFComponents/button";
import { Inline } from "PFComponents/containers";
import Toggle from "PFComponents/toggle/toggle";
import { Tooltip } from "PFComponents/tooltip";
import { Typography } from "PFComponents/typography";
import { useNotificationsMarkAsRead } from "PFCore/hooks/queries/notifications/use_notifications_mark_as_read";
import { useTranslation } from "react-i18next";

import { useNotificationsPanelContext } from "./contexts/notifications_panel_context";
import { useNotificationsMetadata } from "./hooks/use_notifications_metadata";
import css from "./notifications_panel.module.scss";

const NotificationsPanelActions = () => {
  const { t } = useTranslation("translation", { keyPrefix: "notifications" });

  const { categories, showUnreadOnly, setShowUnreadOnly, showImportantOnly, setShowImportantOnly } =
    useNotificationsPanelContext();
  const { mutate: markNotificationsAsRead } = useNotificationsMarkAsRead();
  const { totalUnread } = useNotificationsMetadata();

  const handleMarkAllAsRead = () =>
    markNotificationsAsRead({
      ...(categories.length ? { categories } : { excludedCategories: CHAT_NOTIFICATION_CATEGORIES })
    });
  const handleShowUnreadOnly = (show: boolean) => {
    setShowUnreadOnly(show);
  };
  const handleShowImportantOnly = (show: boolean) => {
    setShowImportantOnly(show);
  };

  return (
    <Inline spread alignItems="center" className={css.actions}>
      <Typography variant="labelRegular" className={css.unreadLabel}>
        {t("totalUnread", { count: totalUnread })}
      </Typography>
      <Inline center gap="spacingLg">
        <Toggle
          label={t("importantOnly")}
          inline
          reversed
          checked={showImportantOnly}
          onChange={handleShowImportantOnly}
        />
        <Toggle
          label={t("unreadOnly")}
          inline
          reversed
          checked={showUnreadOnly}
          onChange={handleShowUnreadOnly}
        />
        <Tooltip content={t("markAllAsRead")}>
          <Button icon="unseen" kind="secondary" onClick={handleMarkAllAsRead} disabled={totalUnread === 0} />
        </Tooltip>
      </Inline>
    </Inline>
  );
};

export default NotificationsPanelActions;
